import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import HeaderMenuButton from "./HeaderMenuButton";

const HeaderNavigation = ({routes}) => {

  return NavigationButtonMaker(routes);
};

function NavigationButtonMaker(allowedRoutesList) {
  let routes = [];

  // Creates a buttons and menu buttons according to the given list
  if (allowedRoutesList && allowedRoutesList.length > 0 ) {

    // The array contains basic header buttons and also
    // Menu buttons where the navigation buttons are inside the menu
    for (let i = 0; i < allowedRoutesList.length; i++) {
      const routeInfo = allowedRoutesList[i];
      
      if (routeInfo.title && routeInfo.pages) {
          routes.push(<HeaderMenuButton key={routeInfo.title} title={routeInfo.title} links={routeInfo.pages} />)
      } else {
        routes.push(<Button key={routeInfo.name} component={Link} to={routeInfo.path} color="inherit">{routeInfo.name} </Button>)
      }

    }
  } else { routes = null }
  return routes;
}

export default HeaderNavigation;


// WEBPACK FOOTER //
// ./src/components/Header/HeaderNavigation.js